// src/constants/dataTypes.js

export const xmlVersions = {
  XMLv1_1: 'XML v1.1 (backward compatible)' ,
  XMLv1_2: 'XML v1.2',
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
